import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d85f3b86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sjjdetail-container" }
const _hoisted_2 = { class: "first-tab" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title1" }, "施工升降机信息", -1))
const _hoisted_4 = { class: "list1" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "备案号：", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "安装日期：", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "安装单位：", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "检测单位：", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title2" }, "司机信息", -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "人脸识别记录", -1))
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "姓名：", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "身份证：", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "资质在线认证：", -1))
const _hoisted_19 = {
  key: 0,
  style: {"color":"#47dd58"}
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "资质证书：", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "高级升降机证", -1))
const _hoisted_23 = ["onClick", "src"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "(可点击)", -1))
const _hoisted_25 = { class: "second-tab" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "切换", -1))
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "jiance" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "实时监测数据", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多信息", -1))
const _hoisted_31 = ["src"]
const _hoisted_32 = ["src"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "载荷(kg)", -1))
const _hoisted_34 = ["src"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "倾角(°)", -1))
const _hoisted_36 = ["src"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "人数(个)", -1))
const _hoisted_38 = ["src"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "速度(m/s)", -1))
const _hoisted_40 = ["src"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "高度(m)", -1))
const _hoisted_42 = ["src"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, "风速(m/s)"),
  /*#__PURE__*/_createElementVNode("div", null, "0 / 100")
], -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "设备告警", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多信息", -1))
const _hoisted_46 = ["src"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设备时间：", -1))
const _hoisted_48 = { class: "bottom-text" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "证书名称：", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "证书所属类型：", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "证书编号：", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "证书有效期（止）：", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "文件：", -1))
const _hoisted_54 = ["src"]
const _hoisted_55 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_overlay = _resolveComponent("van-overlay")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createVNode(_component_van_tabs, {
      active: _ctx.active,
      "onUpdate:active": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.active) = $event)),
      animated: "",
      swipeable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tab, { title: "设备信息" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      src: require('./images/sjj.png')
                    }, null, 8, _hoisted_5)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.sjjdetail.name) + "-", 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.sjjdetail.type === 1 ? "单笼" : "双笼"), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_6,
                      _createElementVNode("span", null, _toDisplayString(_ctx.sjjdetail.deviceNo), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_7,
                      _createElementVNode("span", null, _toDisplayString(_ctx.sjjdetail.installDate ? _ctx.sjjdetail.installDate : "暂无信息"), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _hoisted_8,
                    _createElementVNode("span", null, _toDisplayString(_ctx.sjjdetail.installCompany
                    ? _ctx.sjjdetail.installCompany
                    : "暂无信息"), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_9,
                    _createElementVNode("span", null, _toDisplayString(_ctx.sjjdetail.checkCompany ? _ctx.sjjdetail.checkCompany : "暂无信息"), 1)
                  ])
                ])
              ]),
              _hoisted_10,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.sjjdetail.itemList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "list2",
                  key: index
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, _toDisplayString("施工升降机" +
                  (item.hoistsNo === "1" ? "左笼" : "右笼") +
                  "司机"), 1),
                    _createElementVNode("div", {
                      onClick: ($event: any) => (_ctx.rlHistory(item))
                    }, [
                      _hoisted_12,
                      _createElementVNode("img", {
                        src: require('./images/more.png')
                      }, null, 8, _hoisted_13)
                    ], 8, _hoisted_11)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      (item.driverPhoto)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: item.driverPhoto
                          }, null, 8, _hoisted_14))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: require('@/assets/inspection/zhanwei.svg')
                          }, null, 8, _hoisted_15))
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", null, [
                        _hoisted_16,
                        _createElementVNode("span", null, _toDisplayString(item.driverName ? item.driverName : "暂无信息"), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_17,
                        _createElementVNode("span", null, _toDisplayString(item.driverNo ? item.driverNo : "暂无信息"), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_18,
                        (item.driverName)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, "已通过"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_20, "暂无信息"))
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_21,
                        _hoisted_22,
                        _createElementVNode("img", {
                          onClick: ($event: any) => (_ctx.checkZh(item)),
                          src: require('./images/zhengshu.png')
                        }, null, 8, _hoisted_23),
                        _hoisted_24
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, { title: "实时监测" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(_ctx.changeType ? "施工升降机左笼" : "施工升降机右笼"), 1),
                (_ctx.sjjdetail.type === 2)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeStyle && _ctx.changeStyle(...args)))
                    }, [
                      _hoisted_26,
                      _createElementVNode("img", {
                        src: require('./images/change.png')
                      }, null, 8, _hoisted_27)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", null, [
                  _hoisted_29,
                  _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.morejianceData && _ctx.morejianceData(...args)))
                  }, [
                    _hoisted_30,
                    _createElementVNode("img", {
                      src: require('./images/more.png')
                    }, null, 8, _hoisted_31)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("img", {
                        src: require('./images/jiance1.png')
                      }, null, 8, _hoisted_32)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_33,
                      _createElementVNode("div", null, _toDisplayString(_ctx.elevatorDetail.elevatorLoad.value === undefined
                        ? "暂无数据"
                        : _ctx.elevatorDetail.elevatorLoad.value) + " / " + _toDisplayString(_ctx.elevatorDetail.elevatorLoad.max == null
                        ? 0
                        : _ctx.elevatorDetail.elevatorLoad.max), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("img", {
                        src: require('./images/jiance2.png')
                      }, null, 8, _hoisted_34)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_35,
                      _createElementVNode("div", null, _toDisplayString(_ctx.elevatorDetail.angle.value === undefined
                        ? "暂无数据"
                        : _ctx.elevatorDetail.angle.value) + " / " + _toDisplayString(_ctx.elevatorDetail.angle.max == null
                        ? 0
                        : _ctx.elevatorDetail.angle.max), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("img", {
                        src: require('./images/jiance3.png')
                      }, null, 8, _hoisted_36)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_37,
                      _createElementVNode("div", null, _toDisplayString(_ctx.elevatorDetail.numberOfPeople.value === undefined
                        ? "暂无数据"
                        : _ctx.elevatorDetail.numberOfPeople.value) + " / " + _toDisplayString(_ctx.elevatorDetail.numberOfPeople.max == null
                        ? 0
                        : _ctx.elevatorDetail.numberOfPeople.max), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("img", {
                        src: require('./images/jiance4.png')
                      }, null, 8, _hoisted_38)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_39,
                      _createElementVNode("div", null, _toDisplayString(_ctx.elevatorDetail.speed.value === undefined
                        ? "暂无数据"
                        : _ctx.elevatorDetail.speed.value) + " / " + _toDisplayString(_ctx.elevatorDetail.speed.max == null
                        ? 0
                        : _ctx.elevatorDetail.speed.max), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("img", {
                        src: require('./images/jiance5.png')
                      }, null, 8, _hoisted_40)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_41,
                      _createElementVNode("div", null, _toDisplayString(_ctx.elevatorDetail.height.value === undefined
                        ? "暂无数据"
                        : _ctx.elevatorDetail.height.value) + " / " + _toDisplayString(_ctx.elevatorDetail.height.max == null
                        ? 0
                        : _ctx.elevatorDetail.height.max), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("img", {
                        src: require('./images/jiance6.png')
                      }, null, 8, _hoisted_42)
                    ]),
                    _hoisted_43
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_44,
                _createElementVNode("div", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.moreGaojingData && _ctx.moreGaojingData(...args)))
                }, [
                  _hoisted_45,
                  _createElementVNode("img", {
                    src: require('./images/more.png')
                  }, null, 8, _hoisted_46)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listData, (item, index) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "listdata"
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, _toDisplayString(item.text), 1),
                    _createElementVNode("div", null, [
                      _hoisted_47,
                      _createTextVNode(" " + _toDisplayString(item.deviceTime), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", {
                      class: _normalizeClass({
                  yiban: item.level === 1,
                  yanzhong: item.level === 2,
                  jinji: item.level === 3,
                })
                    }, _toDisplayString(item.level === 1 ? "一般" : item.level === 2 ? "严重" : "紧急"), 3)
                  ])
                ], 512)), [
                  [_vShow, _ctx.listData.length !== 0]
                ])
              }), 128)),
              _withDirectives(_createElementVNode("div", _hoisted_48, " 暂无设备告警记录~~ ", 512), [
                [_vShow, _ctx.listData.length === 0]
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["active"]),
    _createVNode(_component_van_overlay, { show: _ctx.show1 }, {
      default: _withCtx(() => [
        _createVNode(_component_van_loading, {
          type: "spinner",
          color: "#1989fa"
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_dialog, {
      class: "dialog",
      show: _ctx.show,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.show) = $event)),
      title: "资质证书详情",
      "show-cancel-button": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_49,
          _createElementVNode("span", null, _toDisplayString(_ctx.quality.length !== 0 ? _ctx.quality[0].name : "暂无信息"), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_50,
          _createElementVNode("span", null, _toDisplayString(_ctx.quality.length !== 0 ? _ctx.quality[0].typeName : "暂无信息"), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_51,
          _createElementVNode("span", null, _toDisplayString(_ctx.quality.length !== 0 ? _ctx.quality[0].qualificationNum : "暂无信息"), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_52,
          _createElementVNode("span", null, _toDisplayString(_ctx.quality.length !== 0 ? _ctx.quality[0].endDate : "暂无信息"), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_53,
          (_ctx.quality.length !== 0)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.quality[0].fileList[0].url
              }, null, 8, _hoisted_54))
            : (_openBlock(), _createElementBlock("span", _hoisted_55, "暂无信息"))
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}